import FJActionConstant from '../../constant/FJActionConstant'
import FJCanvasStore from "../../store/FJCanvasStore";
import {
  FJCloudAction,
  FJMediaAction,
  FJModalAction,
  FJPreviewAction,
  FJTimeLineAction,
  FJToolbarAction,
  FJUserAction
} from "./FJRoot.action";
import FJProjectAction from "./FJProject.action";
import FJLocalStore from "../../store/FJLocalStore";
import FJUtil from "../../util/FJUtil";
import FJCoreUtil from "../../core/util/FJCoreUtil";
import FJCoreConstant from "../../core/constant/FJCoreConstant";
import {FJAnimationManager, FJTransitionStore} from "fj-graph";
import FJMediaStore from "../../store/FJMediaStore";
import FJConfig from "../../config/FJConfig";
import FJElementStore from "../../store/FJElementStore";
import FJViewConstant from "../../constant/FJViewConstant";
import FJIntroOutroStore from "../../store/FJIntroOutroStore";
import FJWatermarkAction from "./FJWatermark.action";
import FJMedia from "../../store/FJMedia";
import FJPaymentAction from "./FJPayment.action";
import FJExportPreviewAction from "./FJExportPreview.action";
import FJEventConstant from "../../constant/FJEventConstant";
import FJMoreAction from "./FJMore.action";
import FJPaymentStore from "../../store/FJPaymentStore";
import _ from 'lodash'

let FJExportVideoAction = (function () {
  return {

    /**
     * @description 用户输出视频
     */
    userExportVideoAction: function () {
      return (dispatch, getState) => {

        let {MEDIA_STATUS_LINK, MEDIA_STATUS_RETRY, MEDIA_STATUS_DOWNLOADING} = FJViewConstant;
        let {mainLayer, subLayer, subAudioLayer} = getState().timeline.bricks;
        let hasDownloadingGraph = false;
        let hasLinkGraph = false;
        let hasRetryGraph = false;

        [...mainLayer, ...subLayer, ...subAudioLayer].forEach(brick => {
          let status = brick.sourceStatus;
          if (status === MEDIA_STATUS_DOWNLOADING) {
            hasDownloadingGraph = true;
          }
          if (status === MEDIA_STATUS_RETRY) {
            hasRetryGraph = true;
          }
          if (status === MEDIA_STATUS_LINK) {
            hasLinkGraph = true;
          }
        });

        if (hasLinkGraph) {
          dispatch(FJModalAction.showConfirmModalAction({
            headerText: FJLocalStore._('export-media-tip-title'),
            bodyText: FJLocalStore._('export-media-link-tip'),
            hasCancel: false,
            submitText: FJLocalStore._('got-it')
          }));
        } else if (hasRetryGraph) {
          dispatch(FJModalAction.showConfirmModalAction({
            headerText: FJLocalStore._('export-media-tip-title'),
            bodyText: FJLocalStore._('export-media-retry-tip'),
            hasCancel: false,
            submitText: FJLocalStore._('got-it')
          }));
        } else if (hasDownloadingGraph) {
          dispatch(FJModalAction.showConfirmModalAction({
            headerText: FJLocalStore._('export-media-tip-title'),
            bodyText: FJLocalStore._('export-media-downloading-tip'),
            hasCancel: false,
            submitText: FJLocalStore._('got-it')
          }));
        }

        // 判断是否正在播放，如果是就暂停
        let couldExport = () => {
          return getState().timeline.duration && !hasLinkGraph && !hasRetryGraph && !hasDownloadingGraph;
        };

        // 判断时间轴是否存在内容
        if (!couldExport()) {
          return
        }

        dispatch(FJPreviewAction.setVideoPauseAction());
        FJUtil.ealog('timeline_click app export video');
        FJUtil.dealAnonymousProject().then(() => {

          if (!couldExport()) {
            return
          }

          dispatch(this.setExportProgressAction(0));
          dispatch(this.changeExportPanelShowStateAction(true));
        }).catch((e) => {
          console.log(e)
        });
      };
    },

    /**
     * @description 开始输出
     * @param size 视频输出质量
     */
    startExportAction: function (size) {
      return (dispatch, getState) => {
        const exportStartTime = Date.now();
        const {qualitySelected} = getState().exportVideo;
        const {intro, videoName} = getState().intro;
        const {videoEditor} = getState().user;

        // 延迟的目的是避免EXPORT执行时间太长，阻碍界面更新。
        FJCoreUtil.wait(100).then(() => {

          FJUtil.ealog('timeline_export_intro_page_export_ click', {
            resolution: qualitySelected,
            intro,
            videoTitle: videoName,
            videoEditor,
          });

          FJCanvasStore.executeSync(FJCanvasStore.command.EXPORT, {
            type: 'MP4',
            size,
            exportCallback: (data) => {
              switch (data.type) {
                case "progress": {
                  dispatch(this.setExportProgressAction(data.value));
                  break;
                }
                case "error": {
                  console.log('error输出报错:::', data);
                  // TODO 处理输出报错
                  dispatch(this.showExportErrorAction(size));
                  break;
                }
                case "done": {

                  window.FJEvent.dispatch(FJEventConstant.CHANGE_EXPORT_STATUS, 4);

                  // 统计输出成功
                  const state = getState();
                  let {mainLayer, subLayer, subAudioLayer} = state.timeline.bricks;
                  let textStorey = 0; // 传入文字时间线的层数
                  let musicStorey = 0; //	传入音乐时间线的层数
                  let videoStorey = 0; //	传入视频时间线的层数
                  if (mainLayer.find(layer => layer.type === FJCoreConstant.AUDIO)) {
                    musicStorey++;
                  }
                  if (mainLayer.find(layer => layer.type === FJCoreConstant.TEXT_ANIMATION)) {
                    textStorey++;
                  }
                  if (mainLayer.find(layer => layer.type === FJCoreConstant.VIDEO || layer.type === FJCoreConstant.IMAGE)) {
                    videoStorey++;
                  }

                  let subTextY = [];
                  let subVideoY = [];
                  subLayer.forEach(layer => {
                    if ((layer.type === FJCoreConstant.VIDEO || layer.type === FJCoreConstant.IMAGE) && subVideoY.indexOf(layer.y) === -1) {
                      subVideoY.push(layer.y);
                    } else if (layer.type === FJCoreConstant.TEXT_ANIMATION && subTextY.indexOf(layer.y) === -1) {
                      subTextY.push(layer.y);
                    }
                  });
                  textStorey = textStorey + subTextY.length;
                  videoStorey = videoStorey + subVideoY.length;

                  let subAudioY = [];
                  subAudioLayer.forEach(layer => {
                    if (subAudioY.indexOf(layer.y) === -1) {
                      subAudioY.push(layer.y);
                    }
                  });
                  musicStorey = musicStorey + subAudioY.length;

                  let transitionsData = FJTransitionStore.getAllTransitionData();
                  let __cache = [];
                  let transitionCategory = [];
                  let fun = function (name) {
                    let __length = transitionsData.length
                    let __init = 0;
                    let category = '';
                    if (__cache[name]) return __cache[name];

                    while (__init < __length) {
                      if (transitionsData[__init].items.find(item => item.name === name)) {
                        category = transitionsData[__init].category;
                        __cache[name] = category
                      }
                      __init++;
                    }
                    return category;
                  }
                  let transitions = state.timeline.transitions
                  if (transitions) {
                    transitions.forEach(transition => {
                      transitionCategory.push(fun(transition.name))
                    })
                  }

                  let {
                    GET_ALL_DURATION,
                    GET_PROJECT_NAME,
                    GET_ALL_GRAPHS,
                    GET_WATERMARK,
                    GET_RATIO,
                  } = FJCanvasStore.command;

                  let {
                    VIDEO,
                    AUDIO,
                    TEXT_ANIMATION,
                    IMAGE,
                    WIDGET,
                    MULTI_WIDGET,
                    SVG,
                    OVERLAY,
                    DECORATION_OVERLAY,
                    DYNAMIC_LOGO,
                    WATERMARK_IMAGE,
                    WATERMARK_TEXT,
                  } = FJCoreConstant;

                  let {
                    RATIO_LANDSCAPE,
                    RATIO_SOCIAL,
                    RATIO_CINEMATIC,
                    RATIO_VERTICAL,
                    RATIO_SQUARE,
                  } = FJViewConstant;

                  let {STOCK} = FJMedia.MediaFromType();

                  let ratioType = FJCanvasStore.executeSync(GET_RATIO);
                  let ratio = '16:9';
                  let graphs = FJCanvasStore.executeSync(GET_ALL_GRAPHS);
                  let watermark = FJCanvasStore.executeSync(GET_WATERMARK);
                  let {dynamic, simple} = FJAnimationManager.allAnimations();
                  let videoNum = 0;
                  let photoNum = 0;
                  let musicNum = 0;
                  let textName = [];
                  let textCategory = [];
                  let recordScreen = false;
                  let recordWebCam = false;
                  let recordPhoto = false;
                  let overlayCategary = '';
                  let widgetCategary = '';
                  let widgetState = '';
                  let widgetAnimationName = '';
                  let maskType = [];
                  let photoAnimationType = [];
                  let useOpacity = false;
                  let watermarkType = '';
                  let speeds = [];
                  let stockMediaTypes = [];
                  let useFilter = false;
                  let useAdjust = false;

                  let calcEaValue = function (target, value) {
                    let result = target;
                    if (!result.includes(value)) {
                      result = result ? `${result}, ${value}` : value
                    }

                    return result;
                  };
                  let countStockType = function (media) {
                    let obj = {
                      [VIDEO]: 'video',
                      [AUDIO]: 'audio',
                      [IMAGE]: 'photo',
                    }
                    let {type, fromType} = media;
                    if (fromType === STOCK) {
                      let value = obj[type];
                      if (!stockMediaTypes.includes(value)) {
                        stockMediaTypes.push(value);
                      }
                    }
                  };
                  graphs.forEach(graph => {
                    if (graph.getOpacity() !== 1) {
                      useOpacity = true;
                    }

                    if (graph.shouldRenderWithFilter && graph.shouldRenderWithFilter()) {
                      useFilter = true;
                    }

                    if (graph.shouldRenderWithFilter && graph.shouldRenderWithAdjust()) {
                      useAdjust = true;
                    }

                    if (graph.type === VIDEO) {
                      videoNum++;
                      if (graph.getCropType()) maskType.push(graph.getCropType())
                      let media = FJMediaStore.getMediaById(graph.sourceId);
                      let speed = graph.getSpeed();
                      if (media.name && media.name.indexOf('Screen Recording - Made with FlexClip') !== -1) {
                        recordScreen = true;
                      } else if (media.name && media.name.indexOf('Camera Recording - Made with FlexClip') !== -1) {
                        recordWebCam = true;
                      }

                      if (!speeds.includes(speed)) {
                        speeds.push(speed);
                      }

                      countStockType(media);
                    } else if (graph.type === AUDIO) {
                      musicNum++;
                      let media = FJMediaStore.getMediaById(graph.sourceId);
                      countStockType(media);
                    } else if (graph.type === IMAGE) {
                      photoNum++;
                      if (graph.getCropType()) maskType.push(graph.getCropType())
                      if (graph.getAnimationType()) photoAnimationType.push(graph.getAnimationType())
                      let media = FJMediaStore.getMediaById(graph.sourceId);
                      if (media.name && media.name.indexOf('Photo with FlexClip') !== -1) {
                        recordPhoto = true;
                      }
                      countStockType(media);
                    } else if (graph.type === TEXT_ANIMATION) {
                      let name = graph.name;
                      textName.push(name);
                      if (dynamic.find(text => text.name === name)) {
                        textCategory.push('dynamic');
                      } else if (simple.find(text => text.name === name)) {
                        textCategory.push('simple');
                      }
                    } else if (graph.type === OVERLAY || graph.type === DECORATION_OVERLAY || graph.type === DYNAMIC_LOGO) {
                      let __value = '';
                      switch (graph.type) {
                        case OVERLAY:
                          __value = 'overlay for text';
                          break;
                        case DECORATION_OVERLAY:
                          __value = 'overlay for decoration';
                          break;
                        case DYNAMIC_LOGO:
                          __value = 'logo/intro/outro';
                          break;
                        default:
                      }
                      overlayCategary = calcEaValue(overlayCategary, __value);
                    } else if (graph.type === WIDGET || graph.type === MULTI_WIDGET || graph.type === SVG) {
                      switch (graph.type) {
                        case WIDGET:
                        case MULTI_WIDGET:
                          widgetCategary = calcEaValue(widgetCategary, FJElementStore.getCategoryByName(graph.name, 'widget'));
                          widgetState = calcEaValue(widgetState, 'self-built dynamic');
                          break;
                        case SVG:
                          if (graph.fromType !== FJViewConstant.SVG_WEB) {
                            widgetState = calcEaValue(widgetState, 'third-party static');
                          } else {
                            widgetCategary = calcEaValue(widgetCategary, FJElementStore.getCategoryByName(graph.name));
                            widgetState = calcEaValue(widgetState, 'self-built static');
                          }
                          graph.getAnimationSlots().forEach(slot => {
                            let {id, name} = slot;
                            let __type = '';
                            let __name = FJIntroOutroStore.coreNameToViewName(name);
                            let __cate = '';
                            let {animationInData, animationOutData} = FJIntroOutroStore;
                            if (id === FJViewConstant.INTRO) {
                              __type = 'enter';

                              // eslint-disable-next-line max-nested-callbacks
                              __cate = animationInData.find(data => data.list.find(item => item.name === __name)).category;
                            } else if (id === FJViewConstant.OUTRO) {
                              __type = 'exit';

                              // eslint-disable-next-line max-nested-callbacks
                              __cate = animationOutData.find(data => data.list.find(item => item.name === __name)).category;
                            }
                            widgetAnimationName = calcEaValue(widgetAnimationName, `${__type}/${__cate}/${__name}`);
                          });
                          break;
                        default:
                      }
                    }
                  });

                  let recordType = '';
                  if (recordWebCam && recordPhoto) {
                    recordType = 'video&photo';
                  } else if (recordWebCam && !recordPhoto) {
                    recordType = 'video';
                  } else if (!recordWebCam && recordPhoto) {
                    recordType = 'photo';
                  }

                  if (watermark && watermark.hasWatermarkToRender()) {
                    let curWatermark = watermark.getChild();
                    switch (curWatermark.type) {
                      case WATERMARK_IMAGE:
                        watermarkType = 'photo';
                        break;
                      case WATERMARK_TEXT:
                        watermarkType = 'text';
                        break;
                      default:
                    }
                  }

                  switch (ratioType) {
                    case RATIO_LANDSCAPE:
                      ratio = '16:9';
                      break;
                    case RATIO_SQUARE:
                      ratio = '1:1';
                      break;
                    case RATIO_VERTICAL:
                      ratio = '9:16';
                      break;
                    case RATIO_CINEMATIC:
                      ratio = '21:9';
                      break;
                    case RATIO_SOCIAL:
                      ratio = '4:5';
                      break;
                    default:
                  }

                  FJUtil.ealog('export success', {mode: 'timeline'});
                  FJUtil.ealog('timeline_export success', {
                    exportTime: FJUtil.formatTime((Date.now() - exportStartTime) / 1000),
                    duration: FJUtil.formatTime(FJCanvasStore.executeSync(GET_ALL_DURATION)),
                    ratio,
                    textStorey, // 传入文字时间线的层数
                    musicStorey, //	传入音乐时间线的层数
                    videoStorey, //	传入视频时间线的层数
                    quality: `${size.height}P`, //	传入视频分辨率：480p，720p，1080p
                    videoNum, //	传入视频中用户包含视频的数量
                    photoNum, //	传入视频中用户包含图片的数量
                    musicNum, //	传入视频中用户包含音乐的数量
                    textCategory: textCategory.join(','), //	传入文字分类，如dynamic、simple等，用逗号隔开
                    textName: textName.join(','), //	传入文字名称，如hign light等，用逗号隔开
                    videoTitle: FJCanvasStore.executeSync(GET_PROJECT_NAME), //	传入视频名称
                    recordScreen, // 	true或false
                    recordWebCam: recordType, //	传入photo/video/video&photo
                    overlay_categary: overlayCategary,
                    widget_categary: widgetCategary,
                    widget_state: widgetState,
                    widget_animation_name: widgetAnimationName,
                    mask: maskType.join(','),
                    crop: maskType.length > 0,
                    photoAnimation: photoAnimationType.join(','),
                    transitionCategory: transitionCategory.join(','),
                    opacity: useOpacity,
                    watermark_type: watermarkType,
                    speed: speeds.sort().join(','),
                    stock_media_type: stockMediaTypes.join(''),
                    filter: useFilter,
                    adjust: useAdjust,
                  });
                  break;
                }
              }
            },
          });
        });
      }
    },

    startExportGifAction: function (size, fps) {
      return (dispatch) => {
        FJCoreUtil.wait(100).then(() => {
          FJCanvasStore.executeSync(FJCanvasStore.command.EXPORT, {
            type: 'GIF',
            size,
            fps,
            exportCallback: (data) => {
              switch (data.type) {
                case "progress": {
                  dispatch(this.setExportProgressAction(data.value));
                  break;
                }
                case "error": {
                  dispatch(this.showExportErrorAction(size, fps));
                  break;
                }
                case "done": {
                  window.FJEvent.dispatch(FJEventConstant.CHANGE_EXPORT_STATUS, 4);
                  break;
                }
              }
            },
          });
        });
      };
    },

    /**
     * @description 修改 输出视频面板的显示状态
     * @param {boolean} data true: 显示; false: 隐藏;
     * @returns {{data: *, type: string}}
     */
    changeExportPanelShowStateAction: function (data) {
      return {
        type: FJActionConstant.CHANGE_EXPORT_PANEL_SHOW_STATE,
        data: data
      }
    },

    /**
     * @description 点击关闭按钮
     */
    onClickCloseAction: function (status) {
      return (dispatch) => {
        if (status === 3) {
          FJUtil.ealog('timeline_export cancel');
        }
        dispatch(this.closeExportPanelAction());
        FJCanvasStore.executeSync(FJCanvasStore.command.EXPORT_CANCEL);
      };
    },

    /**
     * @description 输出成功后点击继续编辑
     */
    onClickContinueAction: function () {
      return (dispatch) => {
        dispatch(this.closeExportPanelAction());
      };
    },

    /**
     * @description 关闭输出面板的操作
     */
    closeExportPanelAction: function () {
      return (dispatch) => {
        dispatch(this.changeExportPanelShowStateAction(false));
        window.FJEvent.dispatch(FJEventConstant.CHANGE_EXPORT_STATUS, 1);
        FJCanvasStore.executeSync(FJCanvasStore.command.CLEAR_CACHE_VIDEO);
        FJCanvasStore.execute(FJCanvasStore.command.RE_SEEK_AND_RENDER)
      };
    },

    /**
     * @description 下载输出的视频
     */
    onClickDownloadAction: function () {
      return () => {
        // Todo 下载输出视频
        FJCanvasStore.executeSync(FJCanvasStore.command.DOWNLOAD_EXPORT_VIDEO);
      };
    },

    /**
     * @description 设置输出进度
     * @param data
     * @returns {{data: *, type: *}}
     */
    setExportProgressAction: function (data) {
      return {
        type: FJActionConstant.SET_EXPORT_PROGRESS,
        data: data
      };
    },

    /**
     * @description 加入本地zip工程
     * @param zip
     */
    loadProjectForLocalAction: function (zip) {
      return (dispatch) => {
        FJCanvasStore.execute(FJCanvasStore.command.LOAD_FOR_LOCAL, zip).then(() => {
          dispatch(FJMediaAction.updateMediasAction());
          dispatch(FJMediaAction.cutScrollAction(true));
          dispatch(FJTimeLineAction.updateAllTimelineAction());
          dispatch(FJTimeLineAction.updateDurationAction());
          dispatch(FJToolbarAction.updateToolbarAction());
        });
      };
    },

    /**
     * @description 加载在线工程
     * @param data
     */
    loadProjectForOnlineAction: function (data) {
      let _data = data ? JSON.parse(JSON.stringify(data)) : data;
      console.log(_data);
      return (dispatch) => {
        let {
          LOAD_FOR_ONLINE,
          RE_SEEK_AND_RENDER,
          INIT_UNDO,
          GET_PROJECT_NAME,
          GET_VIDEO_EDITOR
        } = FJCanvasStore.command;
        if (!_data) {
          FJCanvasStore.executeSync(INIT_UNDO);
          return;
        }

        let mediaLoadedFunc = _.debounce(() => {
          let { UPDATE_GRAPH_URL, UPDATE_GRAPH_MEDIA_STATUS } = FJCanvasStore.command;
          FJCanvasStore.executeSync(UPDATE_GRAPH_URL);
          FJCanvasStore.executeSync(UPDATE_GRAPH_MEDIA_STATUS);
          dispatch(FJMediaAction.updateMediasAction());
          dispatch(FJTimeLineAction.updateAllTimelineAction());
          dispatch(FJToolbarAction.updateToolbarAction());
          FJCanvasStore.execute(RE_SEEK_AND_RENDER);
        }, 1000, {trailing: true});

        dispatch(FJModalAction.setIsShowLoadingModalAction(true));
        dispatch(FJMediaAction.cutScrollAction(true));
        FJCanvasStore.execute(LOAD_FOR_ONLINE, _data, () => {
          mediaLoadedFunc();
        }).then(() => {
          let projectName = FJCanvasStore.executeSync(GET_PROJECT_NAME);
          dispatch(FJMoreAction.updateRatioTypeFromCoreAction());
          dispatch(FJWatermarkAction.updateWatermarkAction());
          dispatch(FJMediaAction.updateMediasAction());
          dispatch(FJTimeLineAction.updateAllTimelineAction());
          dispatch(FJTimeLineAction.updateDurationAction());
          dispatch(FJModalAction.setIsShowLoadingModalAction(false));
          dispatch(FJMediaAction.checkHaveLinkMediaAction(true));
          dispatch(FJUserAction.updateProjectNameAction(projectName));
          if (projectName !== FJConfig.defaultProjectName) {
            dispatch(FJUserAction.updateExportNameAction(projectName));
          }
          dispatch(FJUserAction.updateEditorNameAction(FJCanvasStore.executeSync(GET_VIDEO_EDITOR)));
          dispatch(FJPreviewAction.setVideoProcessAction('change', 0, {
            isPercent: true,
            flush: true,
            useThrottle: false
          }));
        }).catch(() => {
          dispatch(FJModalAction.setIsShowLoadingModalAction(false));
          dispatch(this.showLoadFailModalAction());
        }).finally(() => {
          FJCanvasStore.executeSync(INIT_UNDO);
          dispatch(FJCloudAction.doCheckWhenCloudSyncAction());
        });
      };
    },

    /**
     * @description 显示加载失败的弹窗
     */
    showLoadFailModalAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('sorry'),
          bodyText: FJLocalStore._('fail-load-project'),
          cancelType: 'cancel',
          onCancel: () => {
            window.location.href = FJConfig.projectPath;
          },
          onSubmit: (callback) => {
            callback();
            if (window.projectData) {
              dispatch(this.loadProjectForOnlineAction(window.projectData))
            }
          },
          submitText: FJLocalStore._('retry')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 显示输出过程报错的弹窗
     */
    showExportErrorAction: function (quality) {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('video-export-error'),
          bodyText: FJLocalStore._('video-export-error-content'),
          cancelType: 'cancel',
          onCancel: (callback) => {
            callback();

            dispatch(this.setExportProgressAction(0));
            window.FJEvent.dispatch(FJEventConstant.CHANGE_EXPORT_STATUS, 1);
            FJCanvasStore.executeSync(FJCanvasStore.command.EXPORT_CANCEL);
            FJCanvasStore.executeSync(FJCanvasStore.command.CLEAR_CACHE_VIDEO);

          },
          submitText: FJLocalStore._('re-export'),
          onSubmit: (callback) => {
            callback();

            FJCanvasStore.executeSync(FJCanvasStore.command.EXPORT_CANCEL);
            FJCanvasStore.executeSync(FJCanvasStore.command.CLEAR_CACHE_VIDEO);
            dispatch(this.startExportAction(quality));

          },
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 根据用户等级获取对应导出分辨率
     * @returns {(function(*): void)|*}
     */
    getResolutionByLevelAction: function () {
      let resolution = '';
      switch (FJPaymentStore.getPaymentLevel()) {
        case FJViewConstant.USER_PAYMENT_FREE:
          resolution = '720';
          break;
        case FJViewConstant.USER_PAYMENT_BASIC:
          resolution = '720';
          break;
        case FJViewConstant.USER_PAYMENT_PLUS:
          resolution = '1080';
          break;
        case FJViewConstant.USER_PAYMENT_BUSINESS:
          resolution = '1080';
          break;
        default:
          resolution = '480';
      }
      return (dispatch) => {
        dispatch(this.setResolutionAction(resolution))
      }
    },

    setResolutionAction: function (resolution) {
      return (dispatch) => {
        dispatch(this.updateResolutionAction(resolution));
        dispatch(FJPaymentAction.updateLimitsAction());
      };
    },

    /**
     * @description 更新输出选择的分辨率
     * @param resolution
     * @return {{type: string, resolution}}
     */
    updateResolutionAction: function (resolution) {
      return {
        type: FJActionConstant.CHANGE_EXPORT_RESOLUTION,
        resolution,
      }
    },

    /**
     * @description 切换intro
     * @param name
     * @param viewSize
     * @param callback
     * @return {(function(*): void)|*}
     */
    changeIntroAction: function (name, viewSize, callback) {
      return (dispatch, getState) => {
        const {ENABLE_INTRO} = FJCanvasStore.command;
        const {videoEditor} = getState().user;
        const {videoName} = getState().intro;
        dispatch(this.updateIntroAction(name));
        if (name === 'NO_INTRO') {
          dispatch(this.updateIntroStatusAction('success'));
          dispatch(FJExportPreviewAction.disableIntroAction(viewSize));
          callback();
        } else {
          dispatch(this.updateIntroStatusAction('loading'));
          FJElementStore.getElementData(FJCoreConstant.WIDGET, name)
            .then((data) => {
              if (getState().intro.intro === name) {
                return FJCanvasStore.execute(ENABLE_INTRO, name, data, {videoName, videoEditor, viewSize});
              }
            })
            .then(() => {
              if (getState().intro.intro === name) {
                dispatch(FJProjectAction.updateGraphsUrlAction());
                dispatch(FJExportPreviewAction.updateExportPreviewDurationAction());
                dispatch(this.updateIntroStatusAction('success'));
              }
            })
            .catch(() => {
              dispatch(this.updateIntroStatusAction('error'));
            })
            .finally(() => {
              if (getState().intro.intro === name) {
                callback();
              }
            });
        }
      };
    },

    updateIntroDataCoreAction: function () {
      return (dispatch, getState) => {
        const {videoEditor} = getState().user;
        const {videoName, intro} = getState().intro;
        FJCanvasStore.executeSync(FJCanvasStore.command.UPDATE_INTRO, intro, videoName, videoEditor);
      }
    },

    /**
     * @description 更新当前intro
     * @param intro
     * @return {{intro, type: string}}
     */
    updateIntroAction: function (intro) {
      return {
        type: FJActionConstant.UPDATE_INTRO,
        intro,
      }
    },

    /**
     * @description 更新intro状态
     * @param status
     * @return {{type: string, status}}
     */
    updateIntroStatusAction: function (status) {
      return {
        type: FJActionConstant.UPDATE_INTRO_STATUS,
        status,
      }
    },

    /**
     * @description 更新用户是否更改过intro的状态
     */
    updateUserChangedIntroAction: function () {
      return {
        type: FJActionConstant.UPDATE_USER_CHANGED_INTRO,
      }
    },

    /**
     * @description 分享youtube
     * @param url
     * @return {(function(*, *): void)|*}
     */
    shareYoutubeAction: function () {
      return (dispatch, getState) => {
        const {isYoutubeSharing} = getState().exportVideo;
        if (isYoutubeSharing) {
          return;
        }
        const {SHARE_TO_YOUTUBE} = FJCanvasStore.command;
        dispatch(this.updateYoutubeIsSharingAction(true));
        dispatch(this.updateYoutubeShareProgressAction(0));
        FJCanvasStore.execute(SHARE_TO_YOUTUBE, (data) => {
          dispatch(this.updateYoutubeShareProgressAction(data.loaded / data.total));
        }).then((id) => {
          dispatch(this.updateYoutubeShareProgressAction(1));
          window.open("https://youtu.be/" + id, "_blank");
        }).catch(err => {
          let confirmData = {
            headerText: FJLocalStore._('share-error-title'),
            cancelType: 'cancel',
            onCancel: (callback) => {
              callback();
              dispatch(this.updateYoutubeIsSharingAction(false));
              dispatch(this.updateYoutubeShareProgressAction(0));
            },
          };
          if (err && err.otherError && err.otherError === 'youtubeSignupRequired') {
            confirmData.bodyText = FJLocalStore._('share-error-no-channel');
            confirmData.submitText = FJLocalStore._('create-channel');
            confirmData.onSubmit = (callback) => {
              callback();
              window.open('https://www.youtube.com/create_channel', '_blank');
            };
          } else if (err && err.errorType && err.errorType === 'network') {
            confirmData.bodyText = FJLocalStore._('re-share-network');
            confirmData.submitText = FJLocalStore._('re-share');
            confirmData.onSubmit = (callback) => {
              callback();
              setTimeout(() => {
                dispatch(this.shareYoutubeAction());
              }, 500);
            };
          } else {
            confirmData.bodyText = FJLocalStore._('share-error-content');
            confirmData.submitText = FJLocalStore._('retry');
            confirmData.onSubmit = (callback) => {
              callback();
              setTimeout(() => {
                dispatch(this.shareYoutubeAction());
              }, 500);
            };
          }
          dispatch(FJModalAction.showConfirmModalAction(confirmData));
        }).finally(() => {
          dispatch(this.updateYoutubeIsSharingAction(false));
          dispatch(this.updateYoutubeShareProgressAction(0));
        })
      };
    },

    /**
     * @description 取消分享youtube
     */
    cancelShareYoutubeAction: function () {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SHARE_TO_YOUTUBE_CANCEL);
        dispatch(this.updateYoutubeIsSharingAction(false));
        dispatch(this.updateYoutubeShareProgressAction(0));
      };
    },

    /**
     * @description 更新youtube分享状态
     * @param isYoutubeSharing
     * @return {{isYoutubeSharing, type: string}}
     */
    updateYoutubeIsSharingAction: function (isYoutubeSharing) {
      return {
        type: FJActionConstant.SET_YOUTUBE_SHARING,
        isYoutubeSharing,
      }
    },

    /**
     * @description 更新youtube分享进度
     * @param progress
     * @return {{progress, type: string}}
     */
    updateYoutubeShareProgressAction: function (progress) {
      return {
        type: FJActionConstant.SET_YOUTUBE_PROGRESS,
        progress,
      }
    },

    /**
     * @description 分享到dropbox
     * @return {(function(*): void)|*}
     */
    shareDropboxAction: function () {
      return (dispatch) => {
        const {SHARE_TO_DROPBOX} = FJCanvasStore.command;
        const failFunc = () => {
          dispatch(FJModalAction.setIsShowDropboxModalAction(false));
          dispatch(FJModalAction.showConfirmModalAction({
            headerText: FJLocalStore._('share-to-dropbox-failed'),
            bodyText: FJLocalStore._('share-to-dropbox-fail-describe'),
            hasCancel: true,
            submitText: FJLocalStore._('retry'),
            onSubmit: (callback) => {
              callback();
              dispatch(this.shareDropboxAction());
            },
          }))
        };

        // 显示进度
        dispatch(FJModalAction.setIsShowDropboxModalAction(true));
        FJCanvasStore.execute(SHARE_TO_DROPBOX)
          .then((data) => {
            dispatch(FJModalAction.setIsShowDropboxModalAction(false));
            if (data) {
              if (data.result) {
                if (window.ealog && window.ealog.addEvent) {
                  window.ealog.addEvent("upload dropbox sucess");
                }
                dispatch(FJModalAction.setIsShowDropboxSuccessModalAction(true, data.url));
              } else {
                failFunc();
              }
            }
          })
          .catch(e => {
            console.log(e);
            if (e.message !== 'abort') {
              failFunc();
            }
          })
      };
    },

    /**
     * @description 取消分享dropbox
     * @return {(function(*): void)|*}
     */
    cancelShareDropboxAction: function () {
      return () => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SHARE_TO_DROPBOX_CANCEL);
      };
    },
  }
})();

export default FJExportVideoAction;
